import _ from 'lodash';

export const getRidOfDuplicates = (array: Array<any>) => _.uniqWith(array, _.isEqual);
